export class Item {
    constructor(public id = "", public locale = "", public value = "", public region = 0) {};
}

export var list: Item[] = [
    new Item("-", "", "-", 0),
    new Item("US", "en-US", "United States", 1),
    new Item("AF", "ps-AF", "Afhanistan", 0),
    new Item("AL", "sq-AL", "Albania", 0),
    new Item("AD", "ca-AD", "Andorra", 6),
    new Item("AR", "es-AR", "Argentina", 11),
    new Item("AU", "en-AU", "Australia", 5),
    new Item("AT", "de-AT", "Austria", 3),
    new Item("BS", "es-BS", "Bahamas", 0),
    new Item("BH", "ar-BH", "Bahrain", 0),
    new Item("BD", "en-BD", "Bangladesh", 0),
    new Item("BB", "es-BB", "Barbados", 0),
    new Item("BE", "de-BE", "Belgium", 6),
    new Item("BZ", "es-BZ", "Belize", 0),
    new Item("BJ", "fr-BJ", "Benin", 0),
    new Item("BO", "", "Bolivia", 0),
    new Item("BR", "", "Brazil", 0),
    new Item("BG", "", "Bulgaria", 3),
    new Item("BF", "", "Burkino Faso", 0),
    new Item("CA", "en-CA", "Canada", 2),
    new Item("IC", "es-IC", "Canary Islands", 6),
    new Item("CF", "", "Central Afrian Republic", 0),
    new Item("TD", "", "Chad", 0),
    new Item("CL", "", "Chile", 0),
    new Item("CN", "zh-CN", "China", 10),
    new Item("CO", "", "Columbia", 0),
    new Item("KM", "", "Comoros", 0),
    new Item("CR", "", "Costa Rica", 0),
    new Item("CI", "", "Cote d'Ivoire", 0),
    new Item("HR", "hr-HR", "Croatia", 3),
    new Item("CU", "", "Cuba", 0),
    new Item("CY", "el-CY", "Cyprus", 8),
    new Item("CZ", "cs-CZ", "Czech Republic", 3),
    new Item("DK", "da-DK", "Denmark", 7),
    new Item("DJ", "", "Djibouti", 0),
    new Item("DM", "", "Dominica", 0),
    new Item("DO", "", "Dominican Republic", 0),
    new Item("EC", "", "Ecuador", 0),
    new Item("EG", "", "Egypt", 0),
    new Item("SV", "", "El Salvador", 0),
    new Item("ER", "", "Eritea", 0),
    new Item("EE", "", "Estonia", 7),
    new Item("ET", "", "Ethiopia", 0),
    new Item("FJ", "", "Fiji", 0),
    new Item("FI", "fi-FI", "Finland", 7),
    new Item("FR", "fr-FR", "France", 6),
    new Item("GA", "", "Gabon", 0),
    new Item("GM", "", "Gambia", 0),
    new Item("GE", "", "Georgia", 0),
    new Item("DE", "de-DE", "Germany", 3),
    new Item("GH", "", "Ghana", 8),
    new Item("HT", "", "Haiti", 0),
    new Item("HN", "", "Honduras", 0),
    new Item("HK", "zh-HK", "Hong Kong", 10),
    new Item("HU", "hu-HU", "Hungary", 3),
    new Item("IS", "is-IS", "Iceland", 8),
    new Item("IN", "", "India", 0),
    new Item("ID", "", "Indonesia", 0),
    new Item("IN", "", "Iran", 0),
    new Item("IQ", "", "Iraq", 0),
    new Item("IL", "iw-IL", "Israel", 8),
    new Item("IE", "en-IE", "Ireland", 8),
    new Item("IT", "it-IT", "Italy", 6),
    new Item("JM", "", "Jamaica", 0),
    new Item("JP", "ja-JP", "Japan", 13),
    new Item("JO", "", "Jordan", 0),
    new Item("KZ", "", "Kazakhstan", 0),
    new Item("KE", "en-KE", "Kenya", 8),
    new Item("KI", "", "Kiribati", 0),
    new Item("KW", "", "Kuwait", 0),
    new Item("KG", "", "Krygyzstan", 0),
    new Item("LA", "", "Laos", 0),
    new Item("LV", "", "Latvia", 0),
    new Item("LB", "", "Lebanon", 0),
    new Item("LS", "", "Lesotho", 0),
    new Item("LR", "", "Liberia", 0),
    new Item("LY", "", "Libya", 0),
    new Item("LI", "", "Liechtenstein", 0),
    new Item("LT", "lt-LT", "Lithuania", 8),
    new Item("LU", "fr-LU", "Luxembourg", 6),
    new Item("MG", "", "Madagascar", 0),
    new Item("MW", "", "Malawi", 0),
    new Item("MY", "ms-MY", "Malaysia", 9),
    new Item("MV", "", "Maldives", 0),
    new Item("ML", "", "Mali", 0),
    new Item("MT", "", "Malta", 8),
    new Item("MX", "es-MX", "Mexico", 11),
    new Item("MH", "", "Marshall Islands", 0),
    new Item("MR", "", "Mauritania", 0),
    new Item("MU", "", "Mauritius", 8),
    new Item("MX", "", "Mexico", 11),
    new Item("FM", "", "Micronesia", 0),
    new Item("MD", "", "Moldova", 0),
    new Item("MC", "", "Monaco", 0),
    new Item("MN", "", "Mongolia", 0),
    new Item("ME", "", "Montenegro", 0),
    new Item("MA", "ar-MA", "Morocco", 8),
    new Item("MZ", "", "Mozambique", 0),
    new Item("MM", "", "Myanmar", 0),
    new Item("NA", "", "Namibia", 0),
    new Item("NR", "", "Nauru", 0),
    new Item("NP", "", "Nepal", 0),
    new Item("NL", "nl-NL", "Netherlands", 6),
    new Item("NZ", "en-NZ", "New Zealand", 5),
    new Item("NI", "", "Nicaragua", 0),
    new Item("NG", "", "Nigeria", 8),
    new Item("NO", "nb-NO", "Norway", 7),
    new Item("OM", "", "Oman", 0),
    new Item("PK", "", "Pakistan", 0),
    new Item("PW", "", "Palau", 0),
    new Item("PA", "", "Panama", 0),
    new Item("PG", "", "Papa New Guinea", 0),
    new Item("PY", "", "Paraguay", 0),
    new Item("PE", "es-PE", "Peru", 11),
    new Item("PH", "", "Philippines", 0),
    new Item("PL", "en-PL", "Poland", 3),
    new Item("PT", "pt-PT", "Portugal", 6),
    new Item("QA", "", "Qatar", 8),
    new Item("RO", "", "Romania", 0),
    new Item("RU", "", "Russia", 8),
    new Item("RW", "", "Rwanda", 0),
    new Item("KN", "", "Saint Kitts and Nevis", 0),
    new Item("LC", "", "Saint Lucia", 0),
    new Item("VC", "", "Saint Vincent, Grenadines", 0),
    new Item("WS", "", "Samoa", 0),
    new Item("SM", "", "San Marino", 0),
    new Item("ST", "", "Sao Tome and Principe", 0),
    new Item("SA", "", "Saudi Arabia", 0),
    new Item("SN", "", "Senegal", 0),
    new Item("RS", "", "Serbia", 0),
    new Item("SC", "", "Seychelles", 0),
    new Item("SL", "", "Sierra Leone", 0),
    new Item("SG", "en-SG", "Singapore", 9),
    new Item("SK", "en-SK", "Slovakia", 3),
    new Item("SI", "en-SI", "Slovenia", 3),
    new Item("SB", "", "Solomon Islands", 0),
    new Item("SO", "", "Somalia", 0),
    new Item("ZA", "en-ZA", "South Africa", 8),
    new Item("KR", "ko-KR", "South Korea", 12),
    new Item("SS", "", "South Sudan", 0),
    new Item("ES", "es-ES", "Spain", 6),
    new Item("LK", "", "Sri Lanka", 0),
    new Item("SD", "", "Sudan", 0),
    new Item("SR", "", "Suriname", 0),
    new Item("SE", "sv-SE", "Sweden", 7),
    new Item("CH", "fr-CH", "Switzerland", 3),
    new Item("SY", "", "Syria", 0),
    new Item("TW", "zh-TW", "Taiwan", 10),
    new Item("TJ", "", "Tajikistan", 0),
    new Item("TZ", "", "Tanzania", 0),
    new Item("TH", "th-TH", "Thailand", 9),
    new Item("TL", "", "Timor-Leste", 0),
    new Item("TG", "", "Togo", 0),
    new Item("TT", "", "Trinidad and Tobago", 0),
    new Item("TN", "", "Tunisia", 0),
    new Item("TR", "tr-TR", "Turkey", 8),
    new Item("TM", "", "Turkmenistan", 0),
    new Item("TV", "", "Tuvalu", 0),
    new Item("UG", "", "Uganda", 0),
    new Item("UA", "", "Ukraine", 8),
    new Item("AE", "ar-AE", "United Arab Emirates", 8),
    new Item("GB", "en-GB", "United Kingdom", 8),
    new Item("UY", "", "Uruguay", 0),
    new Item("UZ", "", "Uzbekistan", 0),
    new Item("VU", "", "Vanuatu", 0),
    new Item("VE", "", "Venezuela", 0),
    new Item("VN", "", "Vietnam", 0),
    new Item("YE", "", "Yemen", 0),
    new Item("ZM", "", "Zambia", 8),
    new Item("ZW", "", "Zimbabwe", 8),
    new Item("SV", "sv-SE", "Åland Islands", 7),
]

export const defaultRegionCountryList: Record<string, Item> = {
    "1": new Item("US", "en-US", "United States", 1),
    "2": new Item("CA", "en-CA", "Canada", 2),
    "3": new Item("DE", "de-DE", "Germany", 3),
    "5": new Item("AU", "en-AU", "Australia", 5),
    "6": new Item("FR", "fr-FR", "France", 6),
    "7": new Item("SE", "sv-SE", "Sweden", 7),
    "8": new Item("GB", "en-GB", "United Kingdom", 8),
    "9": new Item("SG", "en-SG", "Singapore", 9),
    "10": new Item("CN", "zh-CN", "China", 10),
    "12": new Item("KR", "ko-KR", "South Korea", 12),
    "13": new Item("JP", "ja-JP", "Japan", 13),
}
